import { useEffect, useState } from "react";
import { FaMicrochip } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import {
  getInstallationCameraStatusLabel,
  INSTALLATION_CAMERA_STATUSES,
} from "./installationConfigUtils";
import {
  InstallationPickerOption,
  InstallationPickerRow,
  InstallationPickerSheet,
} from "./InstallationPickerSheet";

const InstallationCameraStatusSection = ({
  status,
  onStatusSave,
  disabled,
  saving,
}) => {
  const { t } = useTranslation();
  const [sheetOpen, setSheetOpen] = useState(false);
  const [draftStatus, setDraftStatus] = useState(status || "");

  useEffect(() => {
    if (sheetOpen) {
      setDraftStatus(status || "");
    }
  }, [sheetOpen, status]);

  const currentStatus = status || "";
  const isDirty = draftStatus !== currentStatus;

  const closeSheet = () => {
    setDraftStatus(currentStatus);
    setSheetOpen(false);
  };

  const handleSave = async () => {
    const saved = await onStatusSave(draftStatus);
    if (saved) {
      setSheetOpen(false);
    }
  };

  const subtitle = getInstallationCameraStatusLabel(t, currentStatus);

  return (
    <>
      <InstallationPickerRow
        icon={FaMicrochip}
        iconVariant="status"
        title={t("installation_state_status_label")}
        subtitle={subtitle}
        onClick={() => setSheetOpen(true)}
        disabled={disabled || saving}
      />

      <InstallationPickerSheet
        open={sheetOpen}
        title={t("installation_picker_title_status")}
        dirty={isDirty}
        saving={saving}
        onDismiss={closeSheet}
        onSave={() => void handleSave()}
      >
        {INSTALLATION_CAMERA_STATUSES.map((statusValue) => (
          <InstallationPickerOption
            key={statusValue}
            label={getInstallationCameraStatusLabel(t, statusValue)}
            selected={draftStatus === statusValue}
            onSelect={() => setDraftStatus(statusValue)}
          />
        ))}
      </InstallationPickerSheet>
    </>
  );
};

export default InstallationCameraStatusSection;
